import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Preview.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FadeInImage from 'components/FadeInImage';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';

const Preview = props => {
  const navigate = useNavigate();
  const { backgroundImage, isPlaying, changePlay } = props;
  const { isMobile } = useVerifyIsMobile(650);
  const { playingLive_player_general_icon_backChannel } = useSelector(
    state => state.asset,
  );

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className={`Preview ${isPlaying ? 'playing' : 'background__vcard'}`}>
      {backgroundImage && (
        <>
          <div className="Preview__mobile-header">
            <img
              className="Preview__mobile-header__back"
              src={playingLive_player_general_icon_backChannel}
              alt="back"
              onClick={handleBackClick}
            />
          </div>
          <FadeInImage
            imageAlt={'vcard-background'}
            imageSrc={backgroundImage}
            styles={{ height: `${isMobile ? '577px' :  '464px'}`, maxHeight: '464px',  objectPosition: 'center' }}
            classNames={[`Preview__player ${isPlaying ? 'hidden' : ''}`]}
            width={isMobile ? '100vw' : 657}
            // height={isMobile ? 590 : 445}
          />
        </>
      )}
      <div className={`Preview__fog ${isPlaying ? 'playing' : ''}`} />
    </div>
  );
};

Preview.propTypes = {
  hasPreview: PropTypes.bool,
  backgroundImage: PropTypes.string,
  groupId: PropTypes.string,
};

Preview.defaultProps = {
  hasPreview: false,
  backgroundImage: null,
  groupId: null,
};

export default Preview;
